export const BROADCAST_FROM_LOCAL_PART = "notifications"

// Postmark provisions this stream on every server it creates. Reputation is
// tracked per stream, which is what actually keeps bulk away from support mail.
export const BROADCAST_MESSAGE_STREAM = "broadcast"

export const UNSUBSCRIBE_BASE_URL = "https://productlane.com/unsubscribe"
export const ONE_CLICK_UNSUBSCRIBE_URL =
	"https://productlane.com/api/unsubscribe"

// Fallback for a workspace that has not set up its broadcast subdomain yet.
// Replies still route back to the support inbox through ReplyTo.
export function defaultBroadcastFromEmail(primaryEmail: string): string {
	const domain = primaryEmail.split("@")[1]?.trim().toLowerCase()
	if (!domain) return primaryEmail
	return `${BROADCAST_FROM_LOCAL_PART}@${domain}`
}

// RFC 8058. Gmail and Yahoo require bulk senders to offer one click unsubscribe,
// and mail without these headers gets filtered.
export function oneClickUnsubscribeHeaders(
	unsubscribeToken: string,
): Array<{ Name: string; Value: string }> {
	if (!unsubscribeToken) return []
	const token = encodeURIComponent(unsubscribeToken)
	return [
		{
			Name: "List-Unsubscribe",
			Value: `<${ONE_CLICK_UNSUBSCRIBE_URL}?token=${token}>, <${UNSUBSCRIBE_BASE_URL}?token=${token}>`,
		},
		{ Name: "List-Unsubscribe-Post", Value: "List-Unsubscribe=One-Click" },
	]
}

// Same RFC 8058 headers, shaped for Resend's flat header record.
export function resendUnsubscribeHeaders(
	unsubscribeToken: string,
): Record<string, string> {
	return Object.fromEntries(
		oneClickUnsubscribeHeaders(unsubscribeToken).map(({ Name, Value }) => [
			Name,
			Value,
		]),
	)
}
